<div class="outerview">
  <ng-template #loading>
    <mat-progress-bar class="progress" mode="indeterminate"></mat-progress-bar>
  </ng-template>
  <div class="container" *ngIf="viewLoaded; else loading">
    <br/>
    Please select the type of activity you want to enter.<br/><br/>
    <mat-accordion class="activity-selection">
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div><mat-icon style="vertical-align:bottom; width:auto">checklist</mat-icon>&nbsp;&nbsp;<strong>Council Choice (Form 10784)</strong></div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <p>Council Choice Activities for <strong>Faith, Family, Community, and Life</strong> must be submitted through Form 10784 found on Supreme's website.  Data entered through Form 10784 will be automatically imported into this site once per month to be graded by the State Program Directors.  Click the button below to open Supreme's website.</p>
        <br/>
        <div style="width: auto; text-align: center;">
          <button style="width: auto" mat-raised-button color="primary" (click)="openSupremeSite()">Supreme Form 10784 <mat-icon style="width: auto">open_in_new</mat-icon></button>
        </div>
        <br/><br/>
        <p>Please watch <a href="https://site-842560.bcvp0rtal.com/detail/videos/forms_/video/6222163148001/fraternal-programs-report-form-10784-training-video" target="_blank">this video</a> to learn how to submit Form 10784.</p>
      </mat-expansion-panel>
      
      <!--Membership Activity-->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div><mat-icon style="vertical-align:bottom; width:auto">groups</mat-icon>&nbsp;&nbsp;<strong>Membership Activity</strong></div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="membershipActivityForm">
          <h1>Enter Membership Activity</h1>
          <p>
            <mat-form-field>
              <input matInput type="text" placeholder="Council" formControlName="council" [matAutocomplete]="membershipCouncilAutoComplete">
              <mat-error *ngIf="membershipActivityForm.get('council').invalid">Please select a council</mat-error>
              <mat-autocomplete #membershipCouncilAutoComplete="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let council of filteredCouncilsMembership | async" [value]="council">
                  {{council.id}} - {{council.name}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="standard">
              <mat-label>Your Name</mat-label>
              <input matInput type="text" autocapitalize="words" placeholder="Full Name" formControlName="submitterName">
              <mat-icon matSuffix>person</mat-icon>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="standard">
              <mat-label>Your Email</mat-label>
              <input matInput type="text" inputmode="email" autocapitalize="off" placeholder="name@example.com" formControlName="submitterEmail">
              <mat-icon matSuffix>email</mat-icon>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="standard">
              <mat-label>Your Phone #</mat-label>
              <input matInput type="tel" inputmode="tel" placeholder="123-456-7890" formControlName="submitterPhone">
              <mat-icon matSuffix>phone</mat-icon>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field>
              <mat-select placeholder="Activity Type" formControlName="activityType" [(value)]="selectedMembershipActivity" (selectionChange)="membershipActivitySelected()">
                <mat-option *ngFor="let activityType of this.getMembershipActivities()" [value]="activityType">
                  {{activityType.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </p>
          <p *ngIf="selectedMembershipProgramGroup">
            <img *ngIf="selectedMembershipProgramGroup.icon" style="width: 50px" src="../../assets/{{selectedMembershipProgramGroup.icon}}">
          </p>
          <p>
            <mat-form-field appearance="standard">
              <mat-label>Activity Date</mat-label>
              <input matInput readonly (focus)="activityDatePicker.open()" [matDatepicker]="activityDatePicker" [min]="minDate" [max]="maxDate" placeholder="Activity Date" formControlName="activityDate">
              <mat-datepicker-toggle matSuffix [for]="activityDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #activityDatePicker></mat-datepicker>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="standard">
              <mat-label>Activity Title</mat-label>
              <input matInput type="text" #activityTitle placeholder="(e.g. &quot;Pancake Breakfast&quot;)" maxlength="55" formControlName="activityTitle">
              <mat-icon matSuffix>short_text</mat-icon>
              <mat-hint>{{activityTitle.value.length}} / 55</mat-hint>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="standard">
              <mat-label>Activity Description</mat-label>
              <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows=5 cdkAutosizeMaxRows=10 placeholder="Please enter a description for your activity, including the new member's name and membership number (if available)" formControlName="activityDescription"></textarea>
            </mat-form-field>
          </p>
          <p *ngIf="selectedMembershipActivity">
            You are submitting this report to: <br />
            State {{selectedMembershipProgramGroup.displayName}} Director - <strong>{{selectedMembershipProgramGroup.director.name}}</strong>
          </p>

          <!-- <p>
              Form Status: {{ membershipActivityForm.status }}
          </p> -->
          <!-- <p>
              Form Value: {{ membershipActivityForm.value | json }}
          </p> -->

          <button mat-raised-button color="primary" type="submit" [disabled]="membershipActivityForm.invalid || isSubmitting" (click)="onSubmitMembershipActivity()">Submit Activity</button>
          <div *ngIf="isSubmitting">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        </form>
      </mat-expansion-panel>

      <!--Of the Year Award Nomination-->
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            <div><mat-icon style="vertical-align:bottom; width:auto">grade</mat-icon>&nbsp;&nbsp;<strong>"Of the Year" Award Nomination <span class="duedate">Due April 1st</span></strong></div>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form [formGroup]="nominationForm">
          <h1>Enter "Of the Year" Nomination<br/><span class="duedate">Due April 1st</span></h1>
          <p>
            <mat-form-field>
              <input matInput type="text" placeholder="Council" formControlName="council" [matAutocomplete]="nominationCouncilAutoComplete">
              <mat-error *ngIf="nominationForm.get('council').invalid">Please select a council</mat-error>
              <mat-autocomplete #nominationCouncilAutoComplete="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let council of filteredCouncilsNomination | async" [value]="council">
                  {{council.id}} - {{council.name}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="standard">
              <mat-label>Your Name</mat-label>
              <input matInput type="text" autocapitalize="words" placeholder="Full Name" formControlName="submitterName">
              <mat-icon matSuffix>person</mat-icon>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="standard">
              <mat-label>Your Email</mat-label>
              <input matInput type="text" inputmode="email" autocapitalize="off" placeholder="name@example.com" formControlName="submitterEmail">
              <mat-icon matSuffix>email</mat-icon>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="standard">
              <mat-label>Your Phone #</mat-label>
              <input matInput type="tel" inputmode="tel" placeholder="123-456-7890" formControlName="submitterPhone">
              <mat-icon matSuffix>phone</mat-icon>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field>
              <mat-select placeholder="Nomination Type" formControlName="activityType" [(value)]="selectedNominationType" (selectionChange)="nominationTypeSelected()">
                <mat-option *ngFor="let activityType of this.getNonMembershipMandatoryActivities()" [value]="activityType">
                  {{activityType.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </p>
          <p *ngIf="selectedNominationProgramGroup">
            <img *ngIf="selectedNominationProgramGroup.icon" style="width: 50px" src="../../assets/{{selectedNominationProgramGroup.icon}}">
          </p>
          <p>
            <mat-form-field appearance="standard">
              <mat-label>Nomination Date</mat-label>
              <input matInput readonly (focus)="nominationDatePicker.open()" [matDatepicker]="nominationDatePicker" [min]="minDate" [max]="maxDate" placeholder="Nomination Date" formControlName="activityDate">
              <mat-datepicker-toggle matSuffix [for]="nominationDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #nominationDatePicker></mat-datepicker>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="standard">
              <mat-label>Nomination Title</mat-label>
              <input matInput type="text" #activityTitle placeholder="(e.g. &quot;Knight of the Year - John Smith&quot;)" maxlength="55" formControlName="activityTitle">
              <mat-icon matSuffix>short_text</mat-icon>
              <mat-hint>{{activityTitle.value.length}} / 55</mat-hint>
            </mat-form-field>
          </p>
          <p>
            <mat-form-field appearance="standard">
              <mat-label>Nomination Description</mat-label>
              <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows=5 cdkAutosizeMaxRows=10 placeholder="Please enter detailed information regarding your nomination" formControlName="activityDescription"></textarea>
            </mat-form-field>
          </p>
          <p *ngIf="selectedNominationType">
            You are submitting this report to: <br />
            State {{selectedNominationProgramGroup.displayName}} Director - <strong>{{selectedNominationProgramGroup.director.name}}</strong>
          </p>

          <!-- <p>
              Form Status: {{ nominationForm.status }}
          </p> -->
          <!-- <p>
              Form Value: {{ nominationForm.value | json }}
          </p> -->

          <button mat-raised-button color="primary" type="submit" [disabled]="nominationForm.invalid || isSubmitting" (click)="onSubmitNomination()">Submit Nomination</button>
          <div *ngIf="isSubmitting">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>
    <br/>
  </div>
</div>